import React from 'react';

import { Form, FormInstance, TimePicker } from 'antd';
import { Dayjs } from 'dayjs';
import { t } from 'i18next';

import { useAppSelector } from 'segments/hooks';

import { selectWorkTime } from 'features/config';

type RequiredFormValues = {
  startTime: Dayjs;
  endTime: Dayjs;
};

interface Props<FormData> {
  form: FormInstance<FormData>;
  showStartTime?: boolean;
  endLabel?: string;
  startLabel?: string;
}

export function SelectBookingTime<FormData extends RequiredFormValues>({
  form,
  showStartTime,
  endLabel = t('form-items.select.booking-end'),
  startLabel = t('form-items.select.booking-start')
}: Props<FormData>) {
  const workTime = useAppSelector(selectWorkTime);
  const startTime = Form.useWatch('startTime', form);
  const endTime = Form.useWatch('endTime', form);


  const disabledStartTime = () => ({
    disabledHours: () =>
      Array.from({ length: 24 }, (_, i) => i).filter((hour) =>
      (hour > (endTime?.hour() ?? workTime.closed)
        || hour < workTime.open))
    ,
    disabledMinutes: (selectedHour: number) => {
      if (selectedHour === workTime.closed - 1) {
        return [30];
      }
      if (endTime?.hour() === undefined || endTime?.minute() === undefined || selectedHour === undefined) {
        return [];
      }
      return endTime?.minute() === 0 && selectedHour - endTime?.hour() === 1 ? [30] : [];
    },
  });

  const disabledEndTime = () => ({
    disabledHours: () =>
      Array.from({ length: 24 }, (_, i) => i).filter((hour) =>
      (hour < (startTime?.hour() ?? workTime.open) + 1
        || hour > workTime.closed))
    ,
    disabledMinutes: (selectedHour: number) => {
      if (selectedHour === workTime.closed) {
        return [30];
      }
      if (startTime?.hour() === undefined || startTime?.minute() === undefined || selectedHour === undefined) {
        return [];
      }
      return startTime?.minute() === 30 && selectedHour - startTime?.hour() === 1 ? [0] : [];
    },
  });

  return (
    <>
      <Form.Item
        label={startLabel}
        name={'startTime'}
        style={{ display: showStartTime ? 'block' : 'none' }}
        rules={[{ required: true, message: 'Пожалуйста, выберите временной диапазон!' }]}
      >
        <TimePicker
          format="HH:mm"
          hideDisabledOptions
          minuteStep={30}
          disabledTime={disabledStartTime}
          showNow={false}
          needConfirm={false}
        />
      </Form.Item>
      <Form.Item
        label={endLabel}
        name={'endTime'}
        rules={[{ required: true, message: 'Пожалуйста, выберите временной диапазон!' }]}
      >
        <TimePicker
          format="HH:mm"
          hideDisabledOptions
          minuteStep={30}
          disabledTime={disabledEndTime}
          showNow={false}
          needConfirm={false}
        />
      </Form.Item>
    </>
  );
}
